import React, { useState, useEffect, useCallback, useContext, memo } from "react";

//context
import { AuthContext } from "../../../../common/middlewares/Auth";

//Librerias
import axios from "axios";
import { toast } from "react-hot-toast";

//Componentes de Material UI
import {
  DialogContent,
  DialogActions,
  Dialog,
  Avatar,
  Button,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Box,
  Typography,
  Alert
  //TextField,
} from "@mui/material";

//Estilos
import { createStyles } from "@mui/material/styles";

//Iconos
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";


const ModalSubirFotoStyles = createStyles(() => ({
  linearProgress: {
    position: "absolute",
    width: "100%",
  },
}));

const ModalSubirFoto = ({
  handleOpenDialog,
  open,
  rowData,
  urlImagen,
  setAutoLoad,
}) => {
  //===============================================================================================================================================
  //========================================== Context ============================================================================================
  //===============================================================================================================================================
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  //===============================================================================================================================================
  //========================================== Declaracion de estados =============================================================================
  //===============================================================================================================================================
  /* Setting the state of the component. */
  const [selectedImage, setSelectedImage] = useState({
    file: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    errorFile: false,
    msgFile: "",
  });
  const [data, setData] = useState({
    urlImagen,
  });

  //===============================================================================================================================================
  //========================================== Hooks personalizados ===============================================================================
  //===============================================================================================================================================
  const theme = useTheme();
  const movil = useMediaQuery(theme.breakpoints.down("sm"));
  //===============================================================================================================================================
  //========================================== Funciones ==========================================================================================
  //===============================================================================================================================================
  const classes = ModalSubirFotoStyles();

  /**
   * If the file is valid, set the selected image to the file.
   */
  const onfileChange = (e) => {
    if (e.target.files && e.target?.files.length > 0) {
      if (!validator(e.target.files[0])) {
        setSelectedImage({
          file: e.target.files[0],
        });
      }
    }
  };

  /* Validating the file extension and size. */
  const validator = useCallback(
    (file) => {
      const extension = file.name
        .substring(file.name.lastIndexOf("."), file.name.length)
        .toLowerCase();
      const maxSize = 1064 * 1064;

      if (
        extension !== ".jpeg" &&
        extension !== ".jpg" &&
        extension !== ".png" &&
        extension !== ".tiff" &&
        extension !== ".webp"
      ) {
        setError({
          errorFile: true,
          msgFile:
            "Solo se permiten archivos de tipo jpg, jpeg, png o tiff, por favor revisa e intenta nuevamente",
        });
        return true;
      }
      if (file.size > maxSize) {
        setError({
          errorFile: true,
          msgFile:
            "Solo se permiten imágenes de un tamaño máximo de 1MB, por favor revisa e intenta nuevamente",
        });
        return true;
      }
      return false;
    },
    [setError]
  );

  /* Sending a file to the backend. */
  const submitData = useCallback(async () => {
    const form = new FormData();
    form.append("avatar", selectedImage.file);
    setLoading(true);
    await axios({
      method: "POST",
      baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
      url: `${process.env.REACT_APP_API_SET_UPLOADFOTOCARNET}`,
      data: form,
      headers: {
        "Content-Type": "multipart/form-data",
        token,
      },
    })
      .then((res) => {
        if (res.data.error) {
          throw new Error(res.data.msg);
        }
        toast.success(res.data.msg)
        setLoading(false);
        handleOpenDialog(!open);
        setTimeout(setAutoLoad(true), 2000);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          setLoading(false);
          toast.error(error.message
            ? error.message
            : "Ha ocurrido un error inesperado al enviar los datos de info basica",)
        }
      });
  }, [
    token,
    selectedImage,
    handleOpenDialog,
    open,
    setAutoLoad,
  ]);
  //===============================================================================================================================================
  //========================================== useEffects =========================================================================================
  //===============================================================================================================================================
  /* Setting the state of the component. */
  useEffect(() => {
    if (rowData) {
      setData({
        urlImagen: rowData.urlImagen || null,
      });
    }
    setLoading(false);
  }, [rowData]);

  //===============================================================================================================================================
  //========================================== Renders ============================================================================================
  //===============================================================================================================================================
  /* The above code is a React component that is used to upload an image to the server. */
  if (!data.urlImagen) {
    return (
      <Dialog
        fullScreen={movil}
        open={open}
        onClose={handleOpenDialog}
        PaperProps={{
          component: "form",
          noValidate: "novalidate",
          style: {
            backgroundColor: "#FDEDED",
          },
        }}
      >
        { /* A dialog box that allows you to upload a file. */}
        <DialogContent>
          <Typography align="center">
            <h1>Foto de Carné</h1>
          </Typography>
          {selectedImage.file && (
            <Box display="flex" position="relative">
              <Box
                style={
                  movil
                    ? {
                      marginLeft: "25%",
                      marginBottom: "5px",
                    }
                    : { marginLeft: "35%", marginBottom: "5px" }
                }
              >
                { /* Creating an avatar with the image selected by the user. */}
                <Avatar
                  alt="not fount"
                  src={URL.createObjectURL(selectedImage.file)}
                  sx={{ width: 56, height: 56 }}
                  style={{
                    width: 150,
                    height: 150,
                  }}
                />
                <br />
                {/* A button that removes the image. */}
                <Button
                  variant="outlined"
                  onClick={() => setSelectedImage({ file: null })}
                  style={
                    movil
                      ? {
                        marginLeft: "20%",
                        marginRight: "20%",
                      }
                      : {
                        marginLeft: "20%",
                        marginRight: "20%",
                      }
                  }
                >
                  Remover
                </Button>
              </Box>
            </Box>
          )}
          <br />
          <br />
          { /* A button that allows you to select a file from your computer. */}
          <Box display="flex" position="relative">
            <Box
              style={
                movil
                  ? {
                    marginLeft: "17%",
                    marginBottom: "5px",
                  }
                  : { marginLeft: "30%", marginBottom: "5px" }
              }
            >
              <input
                accept="image/*"
                type="file"
                name="file"
                onChange={onfileChange}
                id="icon-button-file"
                style={{
                  display: "none",
                }}
              />
              <label htmlFor="icon-button-file">
                <Button
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  variant="contained"
                >
                  Seleccionar Archivo
                </Button>
              </label>
            </Box>
          </Box>

          {/* A React component that is rendering a form. */}
          {error.errorFile ? (
            <Alert severity="error">
              <Typography style={{ textAlign: "justify" }} variant="inherit">
                {error.msgFile}
              </Typography>
            </Alert>
          ) : null}
          <Alert severity="warning">
            <Typography style={{ textAlign: "justify" }} variant="inherit">
              Recuerde que está imagen sólo puede ser cargada una vez, al darle
              click al botón enviar no podrá cargar una nueva imagen, aseguresé
              de que sea la imagen correcta.
            </Typography>
          </Alert>
        </DialogContent>
        {/* A button that is disabled if the image is not selected. */}
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            disabled={!selectedImage.file ? true : loading ? true : false}
            onClick={submitData}
          >
            Enviar
            {loading ? (
              <Box
                style={classes.iconLoader}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress size={24} />
              </Box>
            ) : null}
          </Button>
          <Button
            onClick={() => handleOpenDialog()}
            variant="outlined"
            color="inherit"
            disabled={loading}
          >
            cancelar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
};
export default memo(ModalSubirFoto);
